import {
  Box,
  Grid,
  InputLabel,
  LinearProgress,
  ListItemButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import { MdOutlineTableRestaurant } from 'react-icons/md';
import { ImWhatsapp } from 'react-icons/im';
import TodayExperience from '../../../../Widget/Restaurant/TodayExperience';
import { daily_events } from '../../../../Widget/Restaurant/WidgetConfig';
import { PiPicnicTableLight } from 'react-icons/pi';
import ReservationForm from '../../../Pages/Restaurant/components/ReservationForm';
import { formatDate } from '../../../Pages/Restaurant/utils';

const About = ({
  data,
  openingHours,
  selectedTime,
  setSelectedTime,
  handleClose2,
  isLoading,
  setSelectedFloor,
  selectedFloor,
  guest,
  timeError,
  fullyBooked,
  handleSelectTime,
  date,
  onTimeClick,
  onDateClick,
  onGuestChange,
  onBook,
  isAuthenticated,
  onLoginRedirect,
}) => {
  const [read, setRead] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const EVENTFUL = data?.QuerySlot === 'mercury-lagos';
  const IS_TERRACE = data?.QuerySlot === 'the-terrace-lagos';
  const IS_SHIRO = data?.QuerySlot === 'shiro';
  const IS_HARDROCK = data?.QuerySlot === 'hard-rock-cafe';
  const IS_FORNO = data?.QuerySlot === 'forno';

  // Using data for restaurant reference (was undefined in original)
  const restaurant = data;
  return (
    <>
      <Typography
        className={!read && 'four-line-ellipsis'}
        sx={{
          fontWeight: 300,
          textAlign: 'justify',
          fontSize: {
            lg: '12px',
            md: '12px',
            sm: '12px',
            xs: '12px',
          },
          transition: '0.2s all linear',
        }}
      >
        {data?.Description}
      </Typography>
      <span
        onClick={() => setRead(!read)}
        style={{ cursor: 'pointer', textDecoration: 'underline' }}
      >
        {read ? 'Read Less ' : 'Read more'}
      </span>
      <Box
        sx={{
          mt: 2,
          bgcolor: '#fcf4ea',
          p: 1,
          px: 2,
          border: '0.5px solid #d9d9d9',
          borderRadius: '8px',
        }}
      >
        <Typography
          sx={{
            color: '#df8e13',
            fontWeight: 500,
            fontSize: {
              lg: '14px',
              md: '14px',
              sm: '12px',
              xs: '12px',
            },
          }}
        >
          Important Note
        </Typography>
        <Typography
          sx={{
            color: '#df8e13',
            mt: 1,
            fontWeight: 300,
            fontSize: {
              lg: '12px',
              md: '12px',
              sm: '12px',
              xs: '10px',
            },
          }}
        >
          We offer a 15-minute grace period. If you anticipate arriving more
          than 15 minutes past your reservation time, kindly give us a call in
          advance.
        </Typography>
      </Box>

      {/*  */}
      <Box sx={{ display: { md: 'none', xs: 'block' }, mt: 2 }}>
        <ReservationForm
          noButton
          data={data}
          selectedTime={selectedTime}
          date={date}
          guest={guest}
          onTimeClick={onTimeClick}
          onDateClick={onDateClick}
          onGuestChange={onGuestChange}
          onBook={onBook}
          isAuthenticated={isAuthenticated}
          onLoginRedirect={onLoginRedirect}
        />
      </Box>

      {/* CURRENT EXPERIENCE =============== */}
      {data?.Events?.length > 0 && (
        <>
          <TodayExperience events={data?.Events} date={date} />
        </>
      )}

      {EVENTFUL && (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Box>
            {daily_events.map((event, index) => {
              const matching_day = event.day === formatDate(date).split(',')[0];

              return (
                <Box
                  key={index}
                  sx={{
                    background: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('${
                      restaurant?.Photos && restaurant?.Photos[0]?.Link
                    }')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    mt: 1,
                    display: matching_day ? 'flex' : 'none',
                    p: 2,
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 300,
                      color: '#fff',
                      fontSize: '12px',
                    }}
                  >
                    Today's Event
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontFamily: 'optima',
                      color: '#fff',
                      fontSize: '16px',
                    }}
                  >
                    {event.name}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        </Grid>
      )}

      {IS_SHIRO || IS_HARDROCK ? (
        <>
          <Box sx={{ mt: 2, width: '100%' }}>
            <Typography sx={{ textAlign: 'center' }}>
              Select Seating Area
            </Typography>
            <Box
              sx={{
                mt: 1,
                display: 'flex',
                columnGap: 2,
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                px: 1,
              }}
            >
              {data?.FloorPlans?.map((floor, index) => (
                <ListItemButton
                  key={index}
                  onClick={() => {
                    setSelectedFloor(floor?.Id);
                    setSelectedTime(null);
                  }}
                  selected={selectedFloor === floor?.Id}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mt: 0.8,
                    width: '47%',
                    border: '0.5px solid #d3d3d3',
                    bgcolor: '#fff',
                    '&.Mui-selected': {
                      border: '1px solid',
                      borderColor: 'primary.main',
                    },
                  }}
                >
                  <PiPicnicTableLight
                    style={{
                      fontSize: '50px',
                      color:
                        selectedFloor === floor?.Id && IS_TERRACE
                          ? '#013709'
                          : '#bc172f',
                    }}
                  />
                  <Typography
                    sx={{
                      mt: 1,
                      fontWeight: 500,
                      color: selectedFloor === floor?.Id && 'primary.main',
                    }}
                  >
                    {floor?.Name}
                  </Typography>
                </ListItemButton>
              ))}
            </Box>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box>
                <InputLabel sx={{ mt: 4 }}>
                  {' '}
                  {/* Restaurant opens <b>from {data?.OpenFrom}</b> */}
                </InputLabel>
                <Grid container spacing={2} sx={{ mt: 0 }}>
                  {isLoading && (
                    <Box align="center" sx={{ width: '100%', mt: 2 }}>
                      <LinearProgress sx={{ width: '50%' }} />
                      <Typography
                        sx={{
                          color: 'primary.main',
                          fontSize: '10px',
                        }}
                      >
                        Checking for Available Time...
                      </Typography>
                    </Box>
                  )}

                  {!openingHours ||
                  openingHours.length === 0 ||
                  (openingHours[0].length === 0 &&
                    openingHours[1]?.length === 0) ? (
                    <>
                      {!isLoading && (
                        <>
                          <Box sx={{ p: 1, width: '100%', mt: 1 }}>
                            {guest > 9 && IS_FORNO ? (
                              <>
                                <Typography
                                  sx={{
                                    textAlign: 'center',
                                    fontWeight: 300,
                                    fontSize: '12px',
                                  }}
                                >
                                  Please contact the restaurant to confirm your
                                  reservation
                                </Typography>
                                <a
                                  href="https://wa.me/2349161178000"
                                  target="_blank"
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      columnGap: 2,
                                      alignItems: 'center',
                                      mt: 1,
                                    }}
                                  >
                                    <Typography>Chat us here</Typography>
                                    <ImWhatsapp />
                                  </Box>
                                </a>
                              </>
                            ) : (
                              <Typography
                                sx={{
                                  textAlign: 'center',
                                  fontWeight: 300,
                                  fontSize: '12px',
                                }}
                              >
                                <Typography
                                  sx={{
                                    textAlign: 'center',
                                    fontWeight: 600,
                                    color: 'red',
                                  }}
                                >
                                  {timeError}
                                </Typography>
                                You can try selecting another date or guest size
                              </Typography>
                            )}
                          </Box>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {fullyBooked ? (
                        <>
                          {openingHours &&
                            openingHours[0]?.map((time, index) => (
                              <Grid
                                item
                                lg={3}
                                md={3}
                                sm={4}
                                xs={4}
                                key={index}
                              >
                                <ListItemButton
                                  key={index}
                                  onClick={() => {
                                    handleSelectTime(
                                      time?.Time,
                                      time.ReservationPoint,
                                      time?.Deposit,
                                    );
                                  }}
                                  selected={selectedTime === time?.Time}
                                  sx={{
                                    border: '1px solid #d7d7d7',
                                    borderRadius: '8px',
                                    bgcolor: '#bb182f',
                                    color: '#fff',
                                    transition: '0.2s all linear',
                                    '&:hover': {
                                      bgcolor: '#bb182fb7',
                                      border: '3px solid #d7d7d7',
                                    },
                                    '&.Mui-selected': {
                                      bgcolor: '#bb182f',
                                      border: '3px solid #000',
                                    },
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: '10px',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {' '}
                                    {time?.Time}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: '8px',
                                      whiteSpace: 'nowrap',
                                      mt: -1,
                                    }}
                                  >
                                    {' '}
                                    Reserved
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: '8px',
                                      whiteSpace: 'nowrap',
                                      mt: -1,
                                    }}
                                  >
                                    {' '}
                                    Join Waitlist
                                  </Typography>
                                </ListItemButton>
                                {time?.ReservationPoint && (
                                  <Typography
                                    sx={{
                                      textAlign: 'center',
                                      fontSize: '10px',
                                      color: 'primary.main',
                                      fontWeight: 700,
                                    }}
                                  >
                                    +{time?.ReservationPoint?.Value}
                                    pts
                                  </Typography>
                                )}
                              </Grid>
                            ))}
                          {openingHours &&
                            openingHours[1]?.map((time, index) => (
                              <Grid
                                item
                                lg={2}
                                md={2}
                                sm={4}
                                xs={4}
                                key={index}
                              >
                                <ListItemButton
                                  key={index}
                                  onClick={() => {
                                    handleSelectTime(
                                      time?.Time,
                                      time.ReservationPoint,
                                      time?.Deposit,
                                    );
                                  }}
                                  selected={selectedTime === time?.Time}
                                  sx={{
                                    border: '1px solid #d7d7d7',
                                    borderRadius: '8px',
                                    bgcolor: '#bb182f',
                                    color: '#fff',
                                    transition: '0.2s all linear',
                                    '&:hover': {
                                      bgcolor: '#bb182fb7',
                                      border: '3px solid #d7d7d7',
                                    },
                                    '&.Mui-selected': {
                                      bgcolor: '#bb182f',
                                      border: '3px solid #000',
                                    },
                                  }}
                                >
                                  <MdOutlineTableRestaurant />
                                  <Typography
                                    sx={{
                                      fontSize: '10px',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {' '}
                                    {time?.Time}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: '8px',
                                      whiteSpace: 'nowrap',
                                      mt: -1,
                                    }}
                                  >
                                    {' '}
                                    Reserved
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: '8px',
                                      whiteSpace: 'nowrap',
                                      mt: -1,
                                    }}
                                  >
                                    {' '}
                                    Join Waitlist
                                  </Typography>
                                </ListItemButton>
                                {time?.ReservationPoint && (
                                  <Typography
                                    sx={{
                                      textAlign: 'center',
                                      fontSize: '10px',
                                      color: 'primary.main',
                                      fontWeight: 700,
                                    }}
                                  >
                                    +{time?.ReservationPoint?.Value}
                                    pts
                                  </Typography>
                                )}
                              </Grid>
                            ))}
                        </>
                      ) : (
                        <>
                          {openingHours &&
                            openingHours[0]?.map((time, index) => {
                              const IsAvailable = time?.IsAvailable;
                              return (
                                <Grid
                                  item
                                  lg={2}
                                  md={2}
                                  sm={4}
                                  xs={4}
                                  key={index}
                                >
                                  {IsAvailable ? (
                                    <>
                                      <ListItemButton
                                        disabled={!IsAvailable}
                                        onClick={() => {
                                          handleSelectTime(
                                            time?.Time,
                                            time.ReservationPoint,
                                            time?.Deposit,
                                          );
                                        }}
                                        selected={selectedTime === time?.Time}
                                        sx={{
                                          border: '1px solid #d7d7d7',
                                          borderRadius: '8px',
                                          bgcolor: '#bb182f',
                                          color: '#fff',
                                          display: 'flex',
                                          alignItems: 'center',
                                          columnGap: 1,

                                          transition: '0.2s all linear',
                                          '&:hover': {
                                            bgcolor: '#bb182fb7',
                                            border: '3px solid #d7d7d7',
                                          },
                                          '&.Mui-selected': {
                                            bgcolor: '#bb182f',
                                            border: '3px solid #000',
                                          },
                                        }}
                                      >
                                        <MdOutlineTableRestaurant />
                                        <Typography
                                          sx={{
                                            fontSize: '11px',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {' '}
                                          {time?.Time}
                                        </Typography>
                                      </ListItemButton>
                                      {time?.ReservationPoint && (
                                        <Typography
                                          sx={{
                                            textAlign: 'center',
                                            fontSize: '10px',
                                            color: 'primary.main',
                                            fontWeight: 700,
                                          }}
                                        >
                                          +{time?.ReservationPoint?.Value}
                                          pts
                                        </Typography>
                                      )}
                                    </>
                                  ) : (
                                    <ListItemButton
                                      disabled
                                      onClick={() => {
                                        handleSelectTime(
                                          time?.Time,
                                          time.ReservationPoint,
                                          time?.Deposit,
                                        );
                                      }}
                                      selected={selectedTime === time?.Time}
                                      sx={{
                                        border: '1px solid #d7d7d7',
                                        borderRadius: '8px',
                                        bgcolor: '#bb182f',
                                        color: '#fff',
                                        transition: '0.2s all linear',
                                        display: 'flex',
                                        alignItems: 'center',
                                        columnGap: 1,
                                        '&:hover': {
                                          bgcolor: '#bb182fb7',
                                          border: '3px solid #d7d7d7',
                                        },
                                        '&.Mui-selected': {
                                          bgcolor: '#bb182f',
                                          border: '3px solid #000',
                                        },
                                      }}
                                    >
                                      <MdOutlineTableRestaurant />
                                      <Typography
                                        sx={{
                                          fontSize: '10px',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        {' '}
                                        {time?.Time}
                                      </Typography>
                                    </ListItemButton>
                                  )}
                                </Grid>
                              );
                            })}
                          {openingHours &&
                            openingHours[1]?.map((time, index) => {
                              const IsAvailable = time?.IsAvailable;
                              return (
                                <Grid
                                  item
                                  lg={2}
                                  md={2}
                                  sm={4}
                                  xs={4}
                                  key={index}
                                >
                                  {IsAvailable ? (
                                    <>
                                      <ListItemButton
                                        disabled={!IsAvailable}
                                        onClick={() => {
                                          handleSelectTime(
                                            time?.Time,
                                            time.ReservationPoint,
                                            time?.Deposit,
                                          );
                                        }}
                                        selected={selectedTime === time?.Time}
                                        sx={{
                                          border: '1px solid #d7d7d7',
                                          borderRadius: '8px',
                                          bgcolor: '#bb182f',
                                          color: '#fff',
                                          transition: '0.2s all linear',
                                          display: 'flex',
                                          alignItems: 'center',
                                          columnGap: 1,
                                          '&:hover': {
                                            bgcolor: '#bb182fb7',
                                            border: '3px solid #d7d7d7',
                                          },
                                          '&.Mui-selected': {
                                            bgcolor: '#bb182f',
                                            border: '3px solid #000',
                                          },
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontSize: '12px',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {' '}
                                          {time?.Time}
                                        </Typography>
                                      </ListItemButton>
                                      {time?.ReservationPoint && (
                                        <Typography
                                          sx={{
                                            textAlign: 'center',
                                            fontSize: '10px',
                                            color: 'primary.main',
                                            fontWeight: 700,
                                          }}
                                        >
                                          +{time?.ReservationPoint?.Value}
                                          pts
                                        </Typography>
                                      )}
                                    </>
                                  ) : (
                                    <ListItemButton
                                      selected={selectedTime === time?.Time}
                                      disabled
                                      sx={{
                                        border: '1px solid #d7d7d7',
                                        borderRadius: '8px',
                                        bgcolor: '#bb182f',
                                        color: '#fff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        columnGap: 1,
                                        transition: '0.2s all linear',
                                        '&:hover': {
                                          bgcolor: '#bb182fb7',
                                          border: '3px solid #d7d7d7',
                                        },
                                        '&.Mui-selected': {
                                          bgcolor: '#bb182f',
                                          border: '3px solid #000',
                                        },
                                      }}
                                    >
                                      <MdOutlineTableRestaurant />
                                      <Typography
                                        sx={{
                                          fontSize: '10px',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        {' '}
                                        {time?.Time}
                                      </Typography>
                                    </ListItemButton>
                                  )}
                                </Grid>
                              );
                            })}
                        </>
                      )}
                    </>
                  )}
                </Grid>
              </Box>
            </Grid>
          </Box>
        </>
      ) : (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Box sx={{ mt: 4 }}>
            <InputLabel>
              {' '}
              {/* Restaurant opens <b>from {data?.OpenFrom}</b> */}
            </InputLabel>
            <Grid container spacing={2} sx={{ mt: 0 }}>
              {isLoading && (
                <Box align="center" sx={{ width: '100%', mt: 2 }}>
                  <LinearProgress sx={{ width: '50%' }} />
                  <Typography
                    sx={{
                      color: 'primary.main',
                      fontSize: '10px',
                    }}
                  >
                    Checking for Available Time...
                  </Typography>
                </Box>
              )}

              {!openingHours ||
              openingHours.length === 0 ||
              (openingHours[0].length === 0 &&
                openingHours[1]?.length === 0) ? (
                <>
                  {!isLoading && (
                    <>
                      <Box sx={{ p: 1, width: '100%', mt: 1 }}>
                        <Typography
                          sx={{
                            textAlign: 'center',
                            fontWeight: 600,
                          }}
                        >
                          {timeError}
                        </Typography>
                        {guest > 9 && IS_FORNO ? (
                          <>
                            <Typography
                              sx={{
                                textAlign: 'center',
                                fontWeight: 300,
                                fontSize: '12px',
                              }}
                            >
                              Please contact the restaurant to confirm your
                              reservation
                            </Typography>
                            <a
                              href="https://wa.me/2349161178000"
                              target="_blank"
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  columnGap: 2,
                                  alignItems: 'center',
                                  mt: 1,
                                }}
                              >
                                <Typography>Chat us here</Typography>
                                <ImWhatsapp />
                              </Box>
                            </a>
                          </>
                        ) : (
                          <Typography
                            sx={{
                              textAlign: 'center',
                              fontWeight: 300,
                              fontSize: '12px',
                            }}
                          >
                            You can try selecting another date or guest size
                          </Typography>
                        )}
                      </Box>
                    </>
                  )}
                </>
              ) : (
                <>
                  {fullyBooked ? (
                    <>
                      {openingHours &&
                        openingHours[0]?.map((time, index) => (
                          <Grid item lg={2} md={2} sm={4} xs={4} key={index}>
                            <ListItemButton
                              key={index}
                              onClick={() => {
                                handleSelectTime(
                                  time?.Time,
                                  time.ReservationPoint,
                                  time?.Deposit,
                                );
                              }}
                              selected={selectedTime === time?.Time}
                              sx={{
                                border: '1px solid #d7d7d7',
                                borderRadius: '8px',
                                bgcolor: '#bb182f',
                                color: '#fff',
                                transition: '0.2s all linear',
                                '&:hover': {
                                  bgcolor: '#bb182fb7',
                                  border: '3px solid #d7d7d7',
                                },
                                '&.Mui-selected': {
                                  bgcolor: '#bb182f',
                                  border: '3px solid #000',
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: '10px',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {' '}
                                {time?.Time}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: '8px',
                                  whiteSpace: 'nowrap',
                                  mt: -1,
                                }}
                              >
                                {' '}
                                Reserved
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: '8px',
                                  whiteSpace: 'nowrap',
                                  mt: -1,
                                }}
                              >
                                {' '}
                                Join Waitlist
                              </Typography>
                            </ListItemButton>
                            {time?.ReservationPoint && (
                              <Typography
                                sx={{
                                  textAlign: 'center',
                                  fontSize: '10px',
                                  color: 'primary.main',
                                  fontWeight: 700,
                                }}
                              >
                                +{time?.ReservationPoint?.Value}
                                pts
                              </Typography>
                            )}
                          </Grid>
                        ))}
                      {openingHours &&
                        openingHours[1]?.map((time, index) => (
                          <Grid item lg={2} md={2} sm={4} xs={4} key={index}>
                            <ListItemButton
                              key={index}
                              onClick={() => {
                                handleSelectTime(
                                  time?.Time,
                                  time.ReservationPoint,
                                  time?.Deposit,
                                );
                              }}
                              selected={selectedTime === time?.Time}
                              sx={{
                                border: '1px solid #d7d7d7',
                                borderRadius: '8px',
                                bgcolor: '#bb182f',
                                color: '#fff',
                                transition: '0.2s all linear',
                                '&:hover': {
                                  bgcolor: '#bb182fb7',
                                  border: '3px solid #d7d7d7',
                                },
                                '&.Mui-selected': {
                                  bgcolor: '#bb182f',
                                  border: '3px solid #000',
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: '10px',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {' '}
                                {time?.Time}
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: '8px',
                                  whiteSpace: 'nowrap',
                                  mt: -1,
                                }}
                              >
                                {' '}
                                Reserved
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: '8px',
                                  whiteSpace: 'nowrap',
                                  mt: -1,
                                }}
                              >
                                {' '}
                                Join Waitlist
                              </Typography>
                            </ListItemButton>
                            {time?.ReservationPoint && (
                              <Typography
                                sx={{
                                  textAlign: 'center',
                                  fontSize: '10px',
                                  color: 'primary.main',
                                  fontWeight: 700,
                                }}
                              >
                                +{time?.ReservationPoint?.Value}
                                pts
                              </Typography>
                            )}
                          </Grid>
                        ))}
                    </>
                  ) : (
                    <>
                      {openingHours &&
                        openingHours[0]?.map((time, index) => {
                          const IsAvailable = time?.IsAvailable;
                          return (
                            <Grid item lg={2} md={2} sm={4} xs={4} key={index}>
                              {IsAvailable ? (
                                <>
                                  <ListItemButton
                                    disabled={!IsAvailable}
                                    onClick={() => {
                                      handleSelectTime(
                                        time?.Time,
                                        time.ReservationPoint,
                                        time?.Deposit,
                                      );
                                    }}
                                    selected={selectedTime === time?.Time}
                                    sx={{
                                      border: '1px solid #d7d7d7',
                                      borderRadius: '8px',
                                      bgcolor: '#bb182f',
                                      color: '#fff',
                                      transition: '0.2s all linear',
                                      display: 'flex',
                                      alignItems: 'center',
                                      columnGap: 1,
                                      '&:hover': {
                                        bgcolor: '#bb182fb7',
                                        border: '3px solid #d7d7d7',
                                      },
                                      '&.Mui-selected': {
                                        bgcolor: '#bb182f',
                                        border: '3px solid #000',
                                      },
                                    }}
                                  >
                                    <MdOutlineTableRestaurant />
                                    <Typography
                                      sx={{
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {' '}
                                      {time?.Time}
                                    </Typography>
                                  </ListItemButton>
                                  {time?.ReservationPoint && (
                                    <Typography
                                      sx={{
                                        textAlign: 'center',
                                        fontSize: '10px',
                                        color: 'primary.main',
                                        fontWeight: 700,
                                      }}
                                    >
                                      +{time?.ReservationPoint?.Value}
                                      pts
                                    </Typography>
                                  )}
                                </>
                              ) : (
                                <ListItemButton
                                  disabled
                                  onClick={() => {
                                    handleSelectTime(
                                      time?.Time,
                                      time.ReservationPoint,
                                      time?.Deposit,
                                    );
                                  }}
                                  selected={selectedTime === time?.Time}
                                  sx={{
                                    border: '1px solid #d7d7d7',
                                    borderRadius: '8px',
                                    bgcolor: '#bb182f',
                                    color: '#fff',
                                    transition: '0.2s all linear',
                                    display: 'flex',
                                    alignItems: 'center',
                                    columnGap: 1,
                                    '&:hover': {
                                      bgcolor: '#bb182fb7',
                                      border: '3px solid #d7d7d7',
                                    },
                                    '&.Mui-selected': {
                                      bgcolor: '#bb182f',
                                      border: '3px solid #000',
                                    },
                                  }}
                                >
                                  <MdOutlineTableRestaurant />
                                  <Typography
                                    sx={{
                                      fontSize: '10px',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {' '}
                                    {time?.Time}
                                  </Typography>
                                </ListItemButton>
                              )}
                            </Grid>
                          );
                        })}
                      {openingHours &&
                        openingHours[1]?.map((time, index) => {
                          const IsAvailable = time?.IsAvailable;
                          return (
                            <Grid item lg={2} md={2} sm={4} xs={4} key={index}>
                              {IsAvailable ? (
                                <>
                                  <ListItemButton
                                    disabled={!IsAvailable}
                                    onClick={() => {
                                      handleSelectTime(
                                        time?.Time,
                                        time.ReservationPoint,
                                        time?.Deposit,
                                      );
                                    }}
                                    selected={selectedTime === time?.Time}
                                    sx={{
                                      border: '1px solid #d7d7d7',
                                      borderRadius: '8px',
                                      bgcolor: '#bb182f',
                                      color: '#fff',
                                      transition: '0.2s all linear',
                                      display: 'flex',
                                      alignItems: 'center',
                                      columnGap: 1,
                                      '&:hover': {
                                        bgcolor: '#bb182fb7',
                                        border: '3px solid #d7d7d7',
                                      },
                                      '&.Mui-selected': {
                                        bgcolor: '#bb182f',
                                        border: '3px solid #000',
                                      },
                                    }}
                                  >
                                    <MdOutlineTableRestaurant />
                                    <Typography
                                      sx={{
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {' '}
                                      {time?.Time}
                                    </Typography>
                                  </ListItemButton>
                                  {time?.ReservationPoint && (
                                    <Typography
                                      sx={{
                                        textAlign: 'center',
                                        fontSize: '10px',
                                        color: 'primary.main',
                                        fontWeight: 700,
                                      }}
                                    >
                                      +{time?.ReservationPoint?.Value}
                                      pts
                                    </Typography>
                                  )}
                                </>
                              ) : (
                                <ListItemButton
                                  selected={selectedTime === time?.Time}
                                  disabled
                                  sx={{
                                    border: '1px solid #d7d7d7',
                                    borderRadius: '8px',
                                    bgcolor: '#bb182f',
                                    color: '#fff',
                                    transition: '0.2s all linear',
                                    display: 'flex',
                                    alignItems: 'center',
                                    columnGap: 1,
                                    '&:hover': {
                                      bgcolor: '#bb182fb7',
                                      border: '3px solid #d7d7d7',
                                    },
                                    '&.Mui-selected': {
                                      bgcolor: '#bb182f',
                                      border: '3px solid #000',
                                    },
                                  }}
                                >
                                  <MdOutlineTableRestaurant />
                                  <Typography
                                    sx={{
                                      fontSize: '10px',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {' '}
                                    {time?.Time}
                                  </Typography>
                                </ListItemButton>
                              )}
                            </Grid>
                          );
                        })}
                    </>
                  )}
                </>
              )}
            </Grid>

            <Box>
              <Typography sx={{ textAlign: 'center', mt: 4 }}>
                Select Seating Area
              </Typography>
              <Box
                sx={{
                  mt: 1,
                  display: 'flex',
                  columnGap: 2,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  px: 1,
                }}
              >
                {data?.FloorPlans?.map((floor, index) => (
                  <ListItemButton
                    key={index}
                    onClick={() => {
                      setSelectedFloor(floor?.Id);
                      setSelectedTime(null);
                    }}
                    selected={selectedFloor === floor?.Id}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mt: 0.8,
                      width: '47%',
                      border: '0.5px solid #d3d3d3',
                      bgcolor: '#fff',
                      '&.Mui-selected': {
                        border: '1px solid',
                        borderColor: 'primary.main',
                      },
                    }}
                  >
                    <PiPicnicTableLight
                      style={{
                        fontSize: '50px',
                        color:
                          selectedFloor === floor?.Id && IS_TERRACE
                            ? '#013709'
                            : '#bc172f',
                      }}
                    />
                    <Typography
                      sx={{
                        mt: 1,
                        fontWeight: 500,
                        color: selectedFloor === floor?.Id && 'primary.main',
                      }}
                    >
                      {floor?.Name}
                    </Typography>
                  </ListItemButton>
                ))}
              </Box>
            </Box>
          </Box>
        </Grid>
      )}

      {/* <Box
        sx={{
          mt: 4,
          fontSize: {
            lg: '14px',
            md: '14px',
            sm: '12px',
            xs: '12px',
          },
        }}
      >
        Restaurant opens <b>from {data?.OpenFrom}</b>
      </Box>
      <Box sx={{ mt: 4 }}>
        <Grid container spacing={2}>
          <Grid container spacing={2}>
            {!openingHours ||
            openingHours.length === 0 ||
            (openingHours[0].length === 0 && openingHours[1]?.length === 0) ? (
              <>
                <Box sx={{ p: 1, width: '100%', mt: 1 }}>
                  <Typography
                    sx={{
                      textAlign: 'center',
                      fontWeight: 600,
                      color: '#BC172F',
                    }}
                  >
                    No Available Time for the selected date
                  </Typography>
                  <Typography
                    sx={{
                      textAlign: 'center',
                      fontWeight: 300,
                      fontSize: '12px',
                    }}
                  >
                    You can try selecting another date
                  </Typography>
                </Box>
              </>
            ) : (
              <>
                {isMobile ? (
                  <>
                    <Box
                      className="hide_scrollbar"
                      sx={{
                        display: 'flex',
                        ml: 3,
                        overflow: 'scroll',
                        alignItems: 'center',
                        columnGap: 2,
                        mt: 2,
                      }}
                    >
                      {openingHours &&
                        openingHours[0]?.map((time, index) => {
                          return (
                            <Box sx={{}}>
                              <ListItemButton
                                disabled={!time?.IsAvailable}
                                onClick={() => {
                                  setSelectedTime(time?.Time);
                                  handleClose2();
                                }}
                                selected={selectedTime === time?.Time}
                                sx={{
                                  borderRadius: '8px',
                                  bgcolor: '#bb182f',
                                  color: '#fff',
                                  transition: '0.1s all linear',
                                  display: 'flex',
                                  '&:hover': {
                                    bgcolor: '#bb182fb7',
                                    border: '3px solid #d7d7d7',
                                  },
                                  '&.Mui-selected': {
                                    bgcolor: '#bb182f',
                                    border: '3px solid #000',
                                  },
                                }}
                              >
                                <MdOutlineTableRestaurant />
                                <Typography
                                  sx={{
                                    fontSize: '10px',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'center',
                                    width: '100%',
                                  }}
                                >
                                  {' '}
                                  {time?.Time}
                                </Typography>
                              </ListItemButton>
                            </Box>
                          );
                        })}
                      {openingHours &&
                        openingHours[1]?.map((time, index) => {
                          return (
                            <Box sx={{}} key={index}>
                              <ListItemButton
                                disabled={!time?.IsAvailable}
                                onClick={() => {
                                  setSelectedTime(time?.Time);
                                  handleClose2();
                                }}
                                selected={selectedTime === time?.Time}
                                sx={{
                                  borderRadius: '8px',
                                  bgcolor: '#bb182f',
                                  color: '#fff',
                                  transition: '0.1s all linear',
                                  display: 'flex',
                                  '&:hover': {
                                    bgcolor: '#bb182fb7',
                                    border: '3px solid #d7d7d7',
                                  },
                                  '&.Mui-selected': {
                                    bgcolor: '#bb182f',
                                    border: '3px solid #000',
                                  },
                                }}
                              >
                                <MdOutlineTableRestaurant />
                                <Typography
                                  sx={{
                                    fontSize: '10px',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'center',
                                    width: '100%',
                                  }}
                                >
                                  {' '}
                                  {time?.Time}
                                </Typography>
                              </ListItemButton>
                            </Box>
                          );
                        })}
                    </Box>
                  </>
                ) : (
                  <>
                    {openingHours &&
                      openingHours[0]?.map((time, index) => {
                        return (
                          <Grid
                            item
                            lg={2}
                            md={2}
                            sm={3}
                            xs={3}
                            key={index}
                            sx={{}}
                          >
                            <ListItemButton
                              disabled={!time?.IsAvailable}
                              onClick={() => {
                                setSelectedTime(time?.Time);
                                handleClose2();
                              }}
                              selected={selectedTime === time?.Time}
                              sx={{
                                borderRadius: '8px',
                                bgcolor: '#bb182f',
                                color: '#fff',
                                transition: '0.1s all linear',
                                display: 'flex',
                                '&:hover': {
                                  bgcolor: '#bb182fb7',
                                  border: '3px solid #d7d7d7',
                                },
                                '&.Mui-selected': {
                                  bgcolor: '#bb182f',
                                  border: '3px solid #000',
                                },
                              }}
                            >
                              <MdOutlineTableRestaurant />
                              <Typography
                                sx={{
                                  fontSize: '10px',
                                  whiteSpace: 'nowrap',
                                  textAlign: 'center',
                                  width: '100%',
                                }}
                              >
                                {' '}
                                {time?.Time}
                              </Typography>
                            </ListItemButton>
                          </Grid>
                        );
                      })}
                    {openingHours &&
                      openingHours[1]?.map((time, index) => {
                        return (
                          <Grid item lg={2} md={2} sm={3} xs={3} key={index}>
                            <ListItemButton
                              disabled={!time?.IsAvailable}
                              onClick={() => {
                                setSelectedTime(time?.Time);
                                handleClose2();
                              }}
                              selected={selectedTime === time?.Time}
                              sx={{
                                border: '1px solid #d7d7d7',
                                borderRadius: '8px',
                                bgcolor: '#bb182f',
                                color: '#fff',
                                transition: '0.2s all linear',
                                '&:hover': {
                                  bgcolor: '#bb182fb7',
                                  border: '3px solid #d7d7d7',
                                },
                                '&.Mui-selected': {
                                  bgcolor: '#bb182f',
                                  border: '3px solid #000',
                                },
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: '12px',
                                  whiteSpace: 'nowrap',
                                  textAlign: 'center',
                                  width: '100%',
                                }}
                              >
                                {' '}
                                {time?.Time}
                              </Typography>
                            </ListItemButton>
                          </Grid>
                        );
                      })}
                  </>
                )}
              </>
            )}
          </Grid>
        </Grid>
      </Box> */}
    </>
  );
};

export default About;
